import React, { useState, useContext, useEffect } from "react";
import { TaskContext } from "../components/TaskContext";
import { marginBottom } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import TaskChatStory from "./TaskChatStory";
import Alerts from "../components/Alerts";
import { apiRequest } from "../components/Config";
import TaskChatForm from "./TaskChatForm";
import TaskChatFormPzitb from "./TaskChatFormPzitb";
import TaskChatFormReporter from "./TaskChatFormReporter";
import { Row, Col } from "react-bootstrap";
import Button from "@mui/material/Button";

export default function TaskChat() {
  const { taskId } = useContext(TaskContext);
  const { userData } = useContext(UserDataContext);
  const [performer, setPerformer] = useState(null);
  const [performerId, setPerformerId] = useState(null);
  const [reporterMail, setReporterMail] = useState(null);
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [content, setContent] = useState("");
  const [pzitb, setPzitb] = useState(0);
  const [type, setType] = useState(0);
  const [error, setError] = useState("");
  const [insertId, setInsertId] = useState("");
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [show, setShow] = useState(false);
  const [showReporter, setShowReporter] = useState(false);

  const handleContentChange = (event) => {
    const value = event.target.value;
    setContent(value);
    setError(
      value.length > 2000
        ? "Treść zlecenia nie może przekraczać 2000 znaków."
        : ""
    );
  };

  const handleTitleChange = (event) => {
    const value = event.target.value;
    setTitle(value);
    setError(value.length < 1 ? "Nie podano tematu korespondencji." : "");
  };

  const handleAuthorChange = (event) => {
    const value = event.target.value;
    setAuthor(value);
    setError(value.length < 1 ? "Nie podano autora korespondencji." : "");
  };

  const handleSubmit = async () => {
    const values = {
      taskId,
      title,
      content,
      author,
      pzitb,
      reporterMail,
    };

    if (type === 0) {
      values.reporterMail = null;
    }
    console.log("Values : ", values);
    if (pzitb === 1 && author.length === 0) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Błąd",
        severity: "warning",
        info: "Brak autora maila!",
      });
      return;
    } else {
      setShowApiResponse(false);
    }
    if (title.length === 0 || content.length === 0) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Błąd",
        severity: "warning",
        info: "Brak tematu lub treści!",
      });
      return;
    } else {
      setShowApiResponse(false);
    }

    try {
      const response = await apiRequest("newmail", "POST", values);

      console.log("mail response: ", response);
      if (response.error_msg === "sent") {
        setInsertId(response.lastInsertId);
        setShowApiResponse(true);
        setApiResponse({
          title: "Sukces",
          severity: "success",
          info: "Wiadomość wysłana!",
        });
        setTitle("");
        setContent("");
        setAuthor("");
      }
    } catch (error) {
      console.error("Błąd: ", error);
    }
  };

  useEffect(() => {
    if (userData) {
      //console.log("UserData: ", userData);
      const fetchData = async () => {
        try {
          const response = await apiRequest(`taskPerformer/${taskId}`, "GET");
          //console.log("taskData: ", response[0]);
          setPerformer(response[0].performer);
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchData();
    }
  }, [userData, taskId]);

  const handleShow = () => {
    setType(0);
    setShow(!show);

    if (show) {
      setPzitb(0);
    }
    if (!show) {
      setPzitb(1);
    }
  };

  const handleShowReporter = () => {
    setShowReporter(!showReporter);
    setType(1);
  };

  useEffect(() => {
    console.log("TYPE: ", type);
  }, [type]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userData || !userData.userId) return;
      try {
        const response = await apiRequest("task/" + taskId, "GET");
        console.log("taskData: ", response[0]);
        setPerformerId(response[0].performer);
        setReporterMail(response[0].reporterMail);
      } catch (error) {
        console.error("Błąd pobierania danych", error);
      }
    };
    fetchData();
  }, [userData, taskId]);

  /*
  useEffect(() => {
    if (userData) {
      console.log("handleShow PZITB mail", pzitb);
    }
  }, [show]);
*/
  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      {(userData.permId === "1" || userData.permId === "3") && (
        <Row style={{ marginBottom }}>
          <Col>
            <Button
              type="button"
              variant="contained"
              color={"success"}
              onClick={() => handleShow()}
            >
              Dodaj korespondencję PZITB
            </Button>
          </Col>
          <Col>
            <Button
              type="button"
              variant="contained"
              color={"warning"}
              onClick={() => handleShowReporter()}
            >
              Wyślij korespondencję do Zleceniodawcy
            </Button>
          </Col>
        </Row>
      )}
      {userData && show && (
        <TaskChatFormPzitb
          userData={userData}
          title={title}
          content={content}
          error={error}
          handleTitleChange={handleTitleChange}
          handleContentChange={handleContentChange}
          handleAuthorChange={handleAuthorChange}
          handleSubmit={handleSubmit}
        />
      )}
      {userData && showReporter && (
        <TaskChatFormReporter
          userData={userData}
          title={title}
          content={content}
          reporter={reporterMail}
          error={error}
          handleTitleChange={handleTitleChange}
          handleContentChange={handleContentChange}
          handleAuthorChange={handleAuthorChange}
          handleSubmit={handleSubmit}
        />
      )}
      {userData && performer !== null && !show ? (
        <TaskChatForm
          userData={userData}
          title={title}
          content={content}
          error={error}
          handleTitleChange={handleTitleChange}
          handleContentChange={handleContentChange}
          handleSubmit={handleSubmit}
        />
      ) : (
        <p className="p5">
          Utworzenie korespondencji jest możliwe po przydzieleniu Wykonawcy do
          Zlecenia.
        </p>
      )}

      <TaskChatStory insertId={insertId} />
    </div>
  );
}
